/**
 * Created by evgenijsenkevic on 30.08.2024
 * */

const AdminActiveLocationView = cc.Node.extend({
    ctor: function (location) {
        this._super();

        this.location = location;
        this.locationBundles = this.listLocationBundles(location.locationId);

        const styles = cleverapps.styles.AdminActiveLocationView;
        this.setContentSize(styles.width, styles.height);
        this.setAlignment(styles.position);

        this.createLoading();
        this.createButtons();

        cleverapps.bundleLoader.loadBundles(this.locationBundles, {
            onSuccess: this.onLocationLoaded.bind(this)
        });
    },

    listLocationBundles: function (locationId) {
        const bundleId = this.location.getBundleName();
        return [
            bundleId,
            Map2d.getTilesTexture(bundles[bundleId].meta.tiles || locationId),
            Map2d.getUnitsTexture(bundles[bundleId].meta.units || locationId),
            Map2d.getBackgroundBundles(locationId)
        ].filter((bundleName) => bundles[bundleName]);
    },

    cleanup: function () {
        this._super();
        this.unload();
    },

    unload: function () {
        if (this.loaded) {
            this.loaded = false;
            cleverapps.bundleLoader.deleteBundles(this.locationBundles);
        }
    },

    onLocationLoaded: function () {
        const location = bundles[this.location.getBundleName()].jsons.map_json.resolve();
        this.loaded = true;

        if (this.loading) {
            this.loading.removeFromParent();
            this.loading = undefined;
        }

        this.createBg();
        this.createContent(location.data);
    },

    createLoading: function () {
        const loading = this.loading = new LoadingAnimation();
        loading.setAlignment(this.width / 2, this.height / 2);
        this.addChild(loading);
    },

    createBg: function () {
        const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_selected_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(this.getContentSize());
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg);
    },

    createContent: function (location) {
        const styles = cleverapps.styles.AdminActiveLocationView;

        const name = this.name = cleverapps.UI.generateOnlyText(location.location, cleverapps.styles.FONTS.ADMIN_LEVEL_TEXT_SELECTED);

        const preview = this.preview = AdminLevelMiniature.generate(location, styles.preview.map);
        preview.setContentSize2(styles.preview);
        preview.setAnchorPoint(0.5, 0.5);

        const dataView = new AdminLocationDataView(location, styles.dataview);

        const layout = new cleverapps.Layout([name, preview, dataView], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.AdminActiveLocationView.margin
        });

        layout.setAnchorPoint(0.5, 0.5);
        layout.setAlignment(styles.layout);
        this.addChild(layout);
    },

    createButtons: function () {
        const styles = cleverapps.styles.AdminActiveLocationView.buttons;

        const playButton = new cleverapps.UI.Button({
            content: new cc.Sprite(bundles.admin.frames.play_icon),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                cleverapps.administrator.adminLocations.play();
            }
        });

        const editButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.editor,
            content: new cc.Sprite(bundles.admin.frames.edit_icon),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                cleverapps.clipboardService.refreshClipboardData();
                cleverapps.administrator.adminLocations.edit();
            }
        });

        const buttonsLayout = this.buttonsLayout = new cleverapps.Layout([playButton, editButton], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        buttonsLayout.setAlignment(styles);
        this.addChild(buttonsLayout);
    }
});

cleverapps.styles.AdminActiveLocationView = {
    width: 520,
    height: 650,
    margin: 20,

    position: {
        x: { align: "center" },
        y: { align: "center" }
    },

    dataview: {
        width: 500,
        height: 130
    },

    preview: {
        width: 500,
        height: 400,

        map: {
            width: 450,
            height: 450
        },
        x: { align: "center" },
        y: { align: "bottom", dy: 10 }
    },

    name: {
        x: { align: "center" },
        y: { align: "top", dy: -10 }
    },

    buttons: {
        width: 45,
        height: 45,
        x: { align: "center" },
        y: { align: "bottom", dy: -50 },
        margin: 25
    },

    layout: {
        x: { align: "center" },
        y: { align: "center" }
    }
};